import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { getPaginatedData } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";
import Pagination from "./Pagination";
const { REACT_APP_PAYMENT_API_BASEURL } = process.env;

const staticData = [
  {
    name: "Total Records",
    total: 486,
    boxShadow: "Dashboard-color-one",
    color: "color-one",
  },
  {
    name: "Subject Wise",
    total: 35,
    boxShadow: "Dashboard-color-two",
    color: "color-two",
  },
  {
    name: "Course Wise",
    total: 24,
    boxShadow: "Dashboard-color-three",
    color: "color-three",
  },
  {
    name: "Coupon Redemption",
    total: "08",
    boxShadow: "Dashboard-color-four",
    color: "color-four",
  },
];

const TeacherReport = () => {
  const [instructorData, setInstructorData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const { data, startIndex, totalPageCount } = getPaginatedData(
    instructorData,
    currentPage
  );


    
  useEffect(() => {
    const fetch = () => {
      axiosInstance
        .get(`${REACT_APP_PAYMENT_API_BASEURL}/v2/instructor-report`)
        .then((res) => {
      
          setInstructorData(res?.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetch();
  }, []);

  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p> Report For Teachers</p>
        <div>
          <button className="lastmonth-btn">Last Month</button>
          <button className="export-btn">Export</button>
        </div>
      </div>

      <div className="flex-dashboard-new-1">
        {staticData?.map((item, index) => (
          <div className={`box-shadow-06 ${item.boxShadow}`} key={index}>
            <p className="font-custom-p">{item.name}</p>
            <p className={`font-increase ${item.color}`}>{item.total}</p>
          </div>
        ))}
      </div>

      <div className="page-data-new">
        {
        // data?.length > 0 ? (
        //   <p className="showing-result">
        //     Showing page {currentPage} of {totalPageCount} results
        //   </p>
        // ) : 
        
        (
          <p className="showing-result">Showing 0 result</p>
        )}
      </div>

      <div className="instructor-table">
        {
        // data.length === 0 ? (
        //   <Loading />
        // ) : 
        (
          <table className="table-width-100">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Instructor Id</th>
                <th>Instructor Name</th>
                <th>Paid Courses</th>
                <th>Free Courses</th>
                <th>Content Length</th>
              </tr>
            </thead>
            {/* <tbody>
              {data?.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td className="cell">{startIndex+index}</td>
                    <td className="cell">{ele.UserId}</td>
                    <td className="cell">{ele.InstructorName}</td>
                    <td className="cell">{ele.PaidCourses}</td>
                    <td className="cell">{ele.FreeCourses}</td>
                    <td className="cell">
                      {ele?.ContentLength === null ? 0 : ele?.ContentLength}
                    </td>
                  </tr>
                );
              })}
            </tbody> */}
          </table>
        )}
      </div>
      {/* <div className="pageNumbers-sudents">
        <Pagination
          className="pageNumbers-sudents"
          currentPage={currentPage}
          totalCount={10}
          pageSize={totalPageCount}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div> */}
    </div>
  );
};

export default TeacherReport;
